/* global axios */

import CannedResponseAPI from 'dashboard/api/cannedResponse';
import MacrosAPI from 'dashboard/api/macros';

export const fetchMacros = (params = {}) => {
  return axios.get(MacrosAPI.url, { params });
};

export const fetchCannedResponses = ({
  searchKey,
  conversationId,
} = {}) => {
  const params = {};

  if (searchKey) params.search = searchKey;
  if (conversationId) params.conversation_id = conversationId;

  return axios.get(CannedResponseAPI.url, { params });
};
